module.exports = __webpack_public_path__ + "img/character-center.b7d42351.png";